import type { MetadataConflictDialogRequest } from './metadataConflictDialogRequest';
import type { MdfFieldEntity } from '@mimir/common/mdf/fieldDefinition';
import type { FieldValueDiff } from '@mimir/common/dto/mdfModels';
import type { Dictionary } from 'lodash';
import { requestDialog } from './requestDialog';
import { defineAsyncComponent } from '../compat/vueCompat';

const MetadataConflictDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/MetadataConflictDialog.vue'));

export function showMetadataConflictDialog(
  conflicts: FieldValueDiff[],
  fieldsById: Dictionary<MdfFieldEntity>,
  actionFn: () => Promise<void>,
  secondaryActionFn: () => Promise<void>,
  cancelFn: () => void,
) {
  const req: MetadataConflictDialogRequest = {
    conflicts,
    fieldsById,
    actionFn,
    secondaryActionFn,
    cancelFn,
  };

  requestDialog(req, MetadataConflictDialog);
}
